// @ts-nocheck
import camelize from "camelize";

const ERR_TEMPLATE = `
  <div style="
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  ">
    <h2>Incident Manager is unavailable at this time</h2>
  </div>
`;

const baseUrl = window.__SHELL__
  ? window.__SHELL__.remotes.incidents.host
  : window.publicURL;

export const getConfig = () =>
  fetch(`${baseUrl}/config.json`)
    .then((resp) => resp.json())
    .then((config) => {
      window.CONFIG = camelize(config);
    })
    .catch((err) => {
      console.error("Critical error when loading app config:", err);
      if (document && !window.__SHELL__) {
        document.body.innerHTML = ERR_TEMPLATE;
      }
    });
